export default __webpack_public_path__ + "static/media/Kudryashev Headline Sans Web.b671442b.ttf";